/* eslint-disable no-param-reassign */
import React from 'react';
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import Modal, {
  CONTENT_POSITION,
  OPACITY_LAYOUT_COLORS,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@bit/gerenciatd.unifiedcomponents.modal';
import contactBar from '../pages/PortadaPage/contactBarTempleate.json';
import Flyout, {} from '../components/Flyout';

import { createSondaContext } from './contextUtils';

/**
 * Asegura que las imagenes tengan url correcta: si no estas en pro carga la de col10
 * @param {String} url url recibida
 * @returns {String} url formateada
 */
const fixUrlImg = (url) => {
  const urlActual = window.location.href;
  if (urlActual.indexOf('https://www.movistar.es') === -1) {
    return `https://col10mgmt.tsm.inet${url}`;
  }
  return `https://www.movistar.es${url}`;
}

const setUpModalProps = () => {
  Modal.setModalProps({
    contentPosition: CONTENT_POSITION.RIGHT_CENTER,
    opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
    inSceneEffect: IN_SCENE_EFFECT.FADE_IN_RIGHT,
    outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
    closeByClickingOutside: true,
    onCloseHandler: () => console.log('Vamos cerrando'),
  });
};

const openModalPriceCard = (modalInfo) => {
  const info = modalInfo;
  setUpModalProps();
  Modal.setContent(
    <Flyout info={info} option="MICROSOFT_BASIC" Modal={Modal} />
  );
  Modal.show();
}

/**
 * Asegura que los precios con parte decimal tenga el formato correcto (separados por '.')
 * @param {String} pvp precio recibido
 * @returns {String} Precio formateado
 */
const fixPVP = (pvp) => {
  const precio = pvp.split(',');
  if (precio.length > 1) {
    return `${precio[0]}.${precio[1]}`;
  }
  return pvp;
}

/**
 * Asegura que las imagenes tengan el formato correcto (ruta absoluta)
 * @param {String} url url recibida
 * @returns {String} url formateada
 */
const fixUrl = (url) => {
  if (url === '') {
    return url;
  }
  if (!url.includes('://')) {
    return `https://www.movistar.es${url}`;
  }
  return url;
}

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo banner
 * @returns
 * Devuelve la informacion para el modulo del banner
 */
export const moduloBannerSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      components: {
        backgroundImg: (fields.imgDesktop && `https://www.movistar.es${fields.imgDesktop}`) || '',
        backgroundColor: fields.backgroundColor || '',
        'TextInfo-1': {
          text: fields.claim,
          color: 'white',
          kind: 'heading',
          level: 1,
          size: 'title04',
          fontType: 'font-light',
          align: 'left',
          segment: 'emp',
          tabletProps: {
            size: 'display02',
            align: 'center',
          },
          desktopProps: {
            size: 'display02',
            align: 'center',
          },
        },
        'TextInfo-2': {
          text: fields.subClaim,
          color: 'white',
          kind: 'paragraph',
          size: 'caption01',
          fontType: 'font-light',
          align: 'left',
          segment: 'emp',
          tabletProps: {
            size: 'title045',
            align: 'center',
          },
          desktopProps: {
            size: 'title045',
            align: 'center',
          },
        },
      },
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloBannerSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo introduccion
 * @returns
 * Devuelve la informacion para el modulo de introduccion
 */
export const moduloIntroduccionSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      components: {
        image: {
          src: fields.imgDesktop !== '' ? `https://www.movistar.es${fields.imgDesktop}` : 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/imagen-modulo-como-gestionarlo.png',
          alt: fields.alt || fields.title || 'Imagen',
        },
        'TextInfo-1': {
          color: 'blue',
          kind: 'heading',
          level: 2,
          size: 'title05',
          fontType: 'font-regular',
          text: fields.title || '',
          segment: 'emp',
          align: 'center',
          tabletProps: {
            size: 'title03',
            align: 'left',
          },
          desktopProps: {
            size: 'title03',
          },
        },
        'TextInfo-2': {
          kind: 'paragraph',
          color: 'grey6',
          fontType: 'font-regular',
          size: 'title06',
          segment: 'emp',
          text: fields.description || '',
          align: 'left',
          tabletProps: {
            size: 'title05',
            align: 'left',
          },
          desktopProps: {
            size: 'title05',
          },
        },
        Button: fields.buttonLink && fields.buttonText && {
          segment: 'emp',
          buttonType: 'button',
          font: 'regular',
          border: 'no-border-radius',
          textTransform: 'initial',
          size: { h: 'large', w: 'full' },
          tabletProps: { size: { h: 'large', w: 'double' } },
          link: fields.buttonLink,
          label: fields.buttonText,
          color: 'blue',
        },
        imagePosition: fields.align === 'left' ? 'right' : 'left',
        desktopImageHeight: fields.desktopImageHeight || 'top',
        skipPaddingTop: fields.skipPaddingTop || false,
      },

    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloIntroduccionSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de porcentajes
 * @returns
 * Devuelve la informacion para el modulo de porcentajes
 */
export const moduloResultadosPorcentajesSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      components: [
      ],
    }


    const contadores = fields.resultados.reduce((arr, item) => {
      const listItem = {
        count: parseInt(item.fields.claim.replace('%', ''), 10),
        percentage: item.fields.claim.includes('%') ? '%' : '',
        'TextInfo-2': {
          kind: 'paragraph',
          color: 'white',
          fontType: 'font-light',
          size: 'title045',
          segment: 'emp',
          text: item.fields.subClaim || '',
          align: 'center',
          tabletProps: {
            size: 'title04',
          },
          desktopProps: {
            size: 'title04',
          },
        },
      };
      arr = [...arr, listItem];
      return arr;
    }, [])

    newFields.components = contadores;
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloResultadosPorcentajesSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de recomendaciones
 * @returns
 * Devuelve la informacion para el modulo de recomendaciones
 */
export const moduloRecomendacionesSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      bgImage: fields.backGroundImg || 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/fondo-carrousel-productos.jpg',
      components: [
      ],
    }

    const newComponents = {
      titulo: {
        text: fields.title || '',
        size: 'title03',
        kind: 'heading',
        fontType: 'font-light',
        align: 'center',
        level: 2,
        color: 'white',
        className: 'title-margin',
        segment: 'emp',
        tabletProps: {
          size: 'title02',
        },
      },
      subtitulo: {
        text: fields.subTitle || '',
        size: 'title06',
        kind: 'span',
        fontType: 'font-light',
        align: 'left',
        level: 2,
        color: 'white',
        className: 'title-margin',
        segment: 'emp',
        display: 'block',
        tabletProps: {
          size: 'title045',
          align: 'center',
        },
      },
      recom: [
      ],
    };

    let auxPosition = 0;
    const newRecom = fields.recomendaciones.reduce((arr, item) => {
      let auxPosition2 = 1;
      const products = [];
      for (let i = 0; i < item.fields.products.length; i++) {
        const product = {
          productInfoHeight: 'static',
          img: fixUrl(item.fields.products[i].data.fields.urlImg),
          brandImg: {
            src: item.fields.products[i].data.fields.brandImg && item.fields.products[i].data.fields.brandImg.url,
            alt: item.fields.products[i].data.fields.brandImg && item.fields.products[i].data.fields.brandImg.alt,
          },
          components: {
            'TextInfo-1': {
              segment: 'emp',
              color: 'blue-dark',
              kind: 'heading',
              level: 3,
              fontType: 'font-bold',
              align: 'left',
              size: 'title06',
              text: item.fields.products[i].data.fields.nombreComercial,
            },
            'TextInfo-2': {
              segment: 'emp',
              color: 'blue-dark',
              kind: 'paragraph',
              fontType: 'font-regular',
              align: 'left',
              size: 'caption02',
              text: item.fields.products[i].data.fields.ctz_claimPrincipal,
            },
            'CustomLink-1': {
              link: fixUrl(item.fields.products[i].data.fields.urlFicha),
              taggingInfo: {
                componentContent: `destacados-${auxPosition2}`,
                componentName: 'destacados',
                componentProduct: item.fields.products[i].alias.replace('apl_', ''),
                componentPerso: '',
                componentVariation: 'all',
              },
            },
            'Promo-box': {
              bgColor: 'purple',
              TextInfo: {
                segment: 'emp',
                color: 'white',
                kind: 'paragraph',
                level: 3,
                fontType: 'font-regular',
                align: 'left',
                size: 'caption02',
                text: item.fields.products[i].data.fields.bandaPromo,
              },
            },
            'Price-box': {
              bgColor: 'grey8',
              position: 'static',
              textPrice: {
                text: item.fields.products[i].data.fields.textPrice === 'true' ? 'Desde' : '',
                size: 'caption01',
                color: 'blue-light',
                fontType: 'font-regular',
                segment: 'emp',
              },
              prices: [
                {
                  segment: 'emp',
                  color: 'blue-dark',
                  amount: fixPVP(item.fields.products[i].data.fields.pvpTachado),
                  unity: '€',
                  size: 'regular',
                  decoration: 'linethrough',
                  withSpace: false,
                  fontType: 'font-regular',
                },
                {
                  segment: 'emp',
                  color: 'blue-light',
                  amount: fixPVP(item.fields.products[i].data.fields.pvp),
                  unity: item.fields.products[i].data.fields.unidad || '€/mes',
                  size: 'small',
                  decoration: 'none',
                  withSpace: false,
                  fontType: 'font-regular',
                },
              ],
            },
          },
        }
        if (item.fields.products[i].data.fields.pvp === '') {
          product.components['Price-box'] = null;
        }
        if (item.fields.products[i].data.fields.bandaPromo === '') {
          product.components['Promo-box'] = null;
        }
        const auxName = `ProductItemCard-${auxPosition2}`;
        auxPosition2 += 1;
        products[auxName] = product;
      }

      const productListComp = {
        bgColor: '',
        direction: 'column',
        segment: 'emp',
        maxSlidesToShow: 4,
        arrowSize: 'small',
        arrowOpacity: 'op-0-6',
        bgColorArrow: 'black',
        colorArrow: 'white',
        taggingInfo: {
          componentContent: 'fields.alias',
          componentName: 'fields.name',
          componentProduct: '',
          componentPerso: {
            versionTest: '',
          },
          componentVariation: 'all',
        },
        components: products,
      }

      const recom = { question: item.fields.question, ProductList: productListComp, position: auxPosition };
      auxPosition += 1;
      arr = [...arr, recom];
      return arr;
    }, [])

    newComponents.recom = newRecom;
    newFields.components = newComponents;
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    console.log({ error });
    const sonda = new Sonda({
      processName: 'moduloRecomendacionesSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de ventajas
 * @returns
 * Devuelve la informacion para el modulo de ventajas
 */
export const moduloVentajasSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      components: [],
      backgroundImg: `https://www.movistar.es${fields.backgroundImg}`,
    }

    const listItems = fields.ventajas.reduce((arr, item) => {
      const components = { title: item.fields.title, text: item.fields.subTitle, icon: item.fields.icon };
      arr = [...arr, components];
      return arr;
    }, [])

    newFields.components = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloVentajasSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de venta cruzada
 * @returns
 * Devuelve la informacion para el modulo de venta cruzada
 */
export const moduloVentaCruzadaSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      featuredCards: fields.featuredCards || true,
      isSlider: true,
      bgColor: 'grey1',
      bgImage: 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/fd-novedades-empresas.jpg',
      direction: 'column',
      segment: 'emp',
      maxSlidesToShow: 4,
      arrowSize: 'small',
      arrowOpacity: 'op-0-6',
      bgColorArrow: 'black',
      colorArrow: 'white',
      taggingInfo: {
        componentContent: fields.alias,
        componentName: fields.name,
        componentProduct: '',
        componentPerso: {
          versionTest: '',
        },
        componentVariation: 'all',
      },
      components: {
        'TextInfo-1': {
          color: 'white',
          kind: 'heading',
          fontType: 'font-light',
          align: 'center',
          level: 2,
          size: 'title02',
          text: fields.title,
          desktopProps: {
            size: 'title01',
          },
        },
      },
    }

    const products = {};
    fields.products.forEach((product, index) => {
      products[`ProductItemCard-${index}`] = {
        segment: 'emp',
        bgColor: product.data.fields.bandaPromo ? 'purple' : 'white',
        productInfoHeight: 'static',
        img: fixUrl(product.data.fields.urlImg),
        brandImg: {
          src: product.data.fields.brandImg && product.data.fields.brandImg.url,
          alt: product.data.fields.brandImg && product.data.fields.brandImg.alt,
        },
        components: {
          'TextInfo-1': {
            segment: 'emp',
            color: product.data.fields.bandaPromo ? 'white' : 'blue-dark',
            kind: 'heading',
            level: 3,
            fontType: 'font-regular',
            align: 'left',
            size: 'title05',
            text: product.data.fields.nombreComercial,
          },
          'TextInfo-2': {
            segment: 'emp',
            color: product.data.fields.bandaPromo ? 'white' : 'blue-dark',
            kind: 'paragraph',
            fontType: 'font-regular',
            align: 'left',
            size: 'caption02',
            text: product.data.fields.ctz_claimPrincipal,
          },
          'CustomLink-1': {
            link: fixUrl(product.data.fields.urlFicha),
            taggingInfo: {
              componentContent: 'productos-destacados',
              componentName: `productos-destacados-${index + 1}`,
              componentProduct: product.alias,
              componentPerso: '',
              componentVariation: 'all',
            },
          },
          'Promo-box': {
            bgColor: product.data.fields.bandaPromo
              ? 'purple'
              : product.data.fields.bandaDestacada
                ? 'grey5'
                : 'transparent',
            TextInfo: {
              segment: 'emp',
              color: 'white',
              kind: 'paragraph',
              fontType: 'font-regular',
              align: 'left',
              size: 'caption02',
              text: product.data.fields.bandaPromo || product.data.fields.bandaDestacada,
            },
          },
          'Price-box': {
            textPrice: {
              text: product.data.fields.textPrice ? 'Desde' : '',
              size: 'caption01',
              color: product.data.fields.bandaPromo ? 'orchid-dark' : 'blue-light',
              fontType: 'font-regular',
              segment: 'emp',
            },
            bgColor: product.data.fields.bandaPromo ? 'white' : 'grey8',
            position: 'static',
            prices: [
              {
                segment: 'emp',
                color: product.data.fields.pvpTachado ? 'white' : 'grey8',
                amount: product.data.fields.pvpTachado,
                unity: '€',
                size: 'regular',
                decoration: 'linethrough',
                withSpace: false,
                fontType: 'font-light',
              },
              {
                segment: 'emp',
                color: product.data.fields.bandaPromo ? 'orchid-dark' : 'blue-light',
                amount: fixPVP(product.data.fields.pvp),
                unity: '€/mes',
                size: 'small',
                decoration: 'none',
                withSpace: false,
                fontType: 'font-regular',
              },
            ],
          },
        },
      };
    });
    if (Object.keys(products).length > 0) {
      const newComponents = { ...newFields.components, ...products };
      newFields.components = newComponents;
      return newFields;
    }
    return null;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloVentaCruzadaSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo ProductList
 * @param {*} fields Información del modulo de price cards
 * @returns
 * Devuelve la informacion para el modulo de price cards
 */
export const moduloPriceCards = (fields) => {
  try {
    const newFields = {
      // featuredCards: fields.featuredCards === 'true',
      // isSlider: fields.products.length === 2,
      bgColor: fields.bgColor || 'white',
      bgImage: fields.bgImage,
      direction: 'column',
      segment: 'emp',
      maxSlidesToShow: 3,
      arrowSize: 'small',
      arrowOpacity: 'op-0-6',
      bgColorArrow: 'black',
      colorArrow: 'white',
      taggingInfo: {
        componentContent: 'price-cards',
        componentName: 'price-cards',
        componentProduct: '',
        componentPerso: {
          versionTest: '',
        },
        componentVariation: 'all',
      },
      components: {
        'TextInfo-1': {
          color: 'blue',
          kind: 'heading',
          fontType: 'font-regular',
          align: 'left',
          level: 2,
          size: 'title03',
          text: fields.title,
          segment: 'emp',
        },
        'TextInfo-2': {
          color: 'grey8',
          kind: 'paragraph',
          fontType: 'font-regular',
          align: 'left',
          level: 3,
          size: 'caption01',
          tabletProps: {
            size: 'title05',
          },
          text: fields.subTitle,
          segment: 'emp',
        },
      },
    }

    const products = {};
    fields.products.forEach((product, index) => {
      const data = (product && product.data && product.data.fields) || null;
      const flyoutData = (product && product.data && product.data.fields && product.data.fields.FLYOUT_MAS_INFO_COMPLETO && product.data.fields.FLYOUT_MAS_INFO_COMPLETO.fields) || null;
      if (data && flyoutData) {
        const modalInfo = {
          header: {
            'TextInfo-1': {
              segment: 'emp',
              kind: 'heading',
              size: 'title045',
              fontType: 'font-light',
              color: 'white',
              level: 2,
              text: flyoutData.title || '',
            },
          },
          content: {
            id: 'MICROSOFT_BASIC',
            text: flyoutData.description || '',
            align: 'left',
            kind: 'span',
            size: 'caption01',
            color: 'grey5',
            segment: 'emp',
            fontType: 'font-regular',
            level: 1,
            className: '',
            display: 'default',
            backgroundColor: 'transparent',
            decoration: 'none',
            border: 'none',
            footer: {
              'TextInfo-1': {
                segment: 'emp',
                kind: 'paragraph',
                size: 'title06',
                fontType: 'font-light',
                color: 'white',
                text: `${data.textPrice === 'true' || data.textPrice === true ? 'Desde' : ''} ${data.pvp || ''}${data.unidad || ''} ${data.subTitle || ''}`,
              },
              ButtonText: data.textButon,
              'Button-1': {
                label: data.textButon || 'Contratar',
                taggingInfo: {
                  componentContent: 'interes',
                  componentName: 'priceCard-flyout',
                  componentProduct: product.alias,
                  componentPerso: '',
                  componentVariation: 'all',
                },
                segment: 'emp',
                color: 'white_blue',
                size: {
                  h: 'medium',
                  w: 'liquid',
                },
                labelSize: 'small',
                tabletProps: {
                  size: {
                    h: 'large',
                    w: 'liquid',
                  },
                  labelSize: 'medium',
                },
                border: 'no-border-radius',
                textTransform: 'initial',
                link: fixUrl(data.urlContratar),
              },
            },
          },
        };

        products[`ProductItemCard-${index}`] = {
          segment: 'emp',
          layout: 'round',
          width: fields.products.length !== 4 ? 'large' : 'default',
          bgColor: 'white',
          productInfoHeight: '',
          img: data.imgVisible && fixUrl(data.urlImg),
          brandImg: {
            src: data.brandImg && data.brandImg.url,
            alt: data.brandImg && data.brandImg.alt,
          },
          components: {
            'TextInfo-1': {
              segment: 'emp',
              color: 'grey9',
              kind: 'heading',
              level: 3,
              fontType: 'font-regular',
              align: 'left',
              size: 'title06',
              text: data.nombreComercial,
            },
            'TextInfo-2': {
              segment: 'emp',
              color: 'grey9',
              kind: 'paragraph',
              fontType: 'font-regular',
              align: 'left',
              size: 'caption03',
              text: data.subTitle,
            },
            'TextInfo-3': {
              segment: 'emp',
              color: 'grey5',
              kind: 'paragraph',
              fontType: 'font-regular',
              align: 'left',
              size: 'caption02',
              text: '(imp. no incl.)',
            },
            // 'TextInfo-4': {
            //   segment: 'emp',
            //   color: 'grey9',
            //   kind: 'paragraph',
            //   fontType: 'font-regular',
            //   align: 'left',
            //   size: 'caption02',
            //   text: data.ctz_claimPrincipal,
            // },
            'CustomLink-1': {
              link: data.urlFicha,
              taggingInfo: {
                componentContent: 'price-card',
                componentName: 'price-cards',
                componentProduct: product.alias,
                componentPerso: '',
                componentVariation: 'all',
              },
            },
            ...(data.bandaPromo ? {
              'Promo-box': {
                bgColor: 'orchid',
                TextInfo: {
                  segment: 'emp',
                  color: 'white',
                  kind: 'paragraph',
                  fontType: 'font-regular',
                  align: 'left',
                  size: 'caption02',
                  text: data.bandaPromo || data.bandaDestacada,
                },
              },
            } : {}),
            ...(data.bandaDestacada ? {
              'Promo-box': {
                bgColor: 'grey5',
                TextInfo: {
                  segment: 'emp',
                  color: 'white',
                  kind: 'paragraph',
                  fontType: 'font-regular',
                  align: 'left',
                  size: 'caption02',
                  text: data.bandaDestacada,
                },
              },
            } : {}),
            'Price-box': {
              bgColor: 'transparent',
              position: 'static',
              textPrice: {
                text: data.textPrice ? 'Desde' : '',
                size: 'caption01',
                color: 'grey9',
                fontType: 'font-regular',
                segment: 'emp',
              },
              prices: [
                {
                  segment: 'emp',
                  color: 'grey9',
                  amount: fixPVP(data.pvpTachado),
                  unity: data.unidad,
                  size: 'regular',
                  decoration: 'linethrough',
                  withSpace: false,
                  fontType: 'font-light',
                },
                {
                  segment: 'emp',
                  color: 'grey9',
                  amount: fixPVP(data.pvp),
                  unity: data.unidad,
                  size: 'small',
                  decoration: 'none',
                  withSpace: false,
                  fontType: 'font-regular',
                },
              ],
            },
            'Button-1': {
              label: data.textButon || 'Contratar',
              taggingInfo: {
                componentContent: 'interes',
                componentName: 'priceCard',
                componentProduct: product.alias,
                componentPerso: '',
                componentVariation: 'all',
              },
              segment: 'emp',
              color: 'blue',
              size: {
                h: 'medium',
                w: 'liquid',
              },
              labelSize: 'small',
              font: 'regular',
              border: 'no-border-radius',
              textTransform: 'initial',
              link: fixUrl(data.urlContratar),
            },
            'Button-2': {
              label: flyoutData.title || '¿Qué incluye?',
              taggingInfo: {
                componentContent: 'button-flyout',
                componentName: 'priceCard',
                componentProduct: product.alias,
                componentPerso: '',
                componentVariation: 'all',
              },
              segment: 'emp',
              color: 'white_blue',
              size: {
                h: 'medium',
                w: 'liquid',
              },
              labelSize: 'small',
              font: 'regular',
              border: 'no-border-radius',
              textTransform: 'initial',
              onClick: () => openModalPriceCard(modalInfo),
            },
          },
        };
      }
    });
    if (Object.keys(products).length > 0) {
      const newComponents = { ...newFields.components, ...products };
      newFields.components = newComponents;
      return newFields;
    }
    return null;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloPriceCards',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de explora nuestras soluciones
 * @returns
 * Devuelve la informacion para el modulo de explora nuestras soluciones
 */
export const moduloSolucionesSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      textInfo1: {
        text: fields.title || '',
        size: 'title02',
        kind: 'heading',
        fontType: 'font-light',
        align: 'center',
        level: 1,
        color: 'grey6',
        className: 'title-margin',
        segment: 'emp',
      },
      components: [],
      taggingInfo: {
        componentVariation: 'all',
        componentProduct: '',
      },
    }

    const listItems = fields.soluciones.reduce((arr, item) => {
      const components = {
        title: {
          kind: 'heading',
          level: 4,
          align: 'center',
          size: 'title04',
          fontType: 'font-regular',
          color: 'blue',
          text: item.fields.title || '',
          segment: 'emp',
        },
        text: {
          kind: 'paragraph',
          align: 'center',
          size: 'title045',
          fontType: 'font-light',
          color: 'black',
          text: item.fields.description || '',
          segment: 'emp',
        },
        image: (item.fields.urlImg && `https://www.movistar.es${item.fields.urlImg}`) || '',
        link: (item.fields.urlFicha && `https://www.movistar.es${item.fields.urlFicha}`) || '',
      }
      arr = [...arr, components];
      return arr;
    }, [])

    newFields.components = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloSolucionesSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de frase destacada
 * @returns
 * Devuelve la informacion para el módulo de frase destacada
 */
export const moduloFraseDestacada = (fields) => {
  if (fields.soluciones && fields.soluciones[0].fields) {
    const phraseItem = fields.soluciones[0].fields
    try {
      const newFields = {
        components: {
          'TextInfo-1': {
            text: phraseItem.description || '',
            color: phraseItem.colorDescription || 'grey6',
            kind: 'paragraph',
            size: phraseItem.font || 'title03',
            fontType: 'font-regular',
            segment: 'emp',
            align: 'center',
          },

          'TextInfo-2': phraseItem.titleAuthor && {
            color: phraseItem.colorTitleAuthor || 'grey6',
            kind: 'paragraph',
            size: 'title06',
            fontType: 'font-regular',
            text: phraseItem.titleAuthor || '',
            segment: 'emp',
            align: 'center',
          },

          'Button-1': phraseItem.buttonLink && phraseItem.buttonText && {
            segment: 'emp',
            label: phraseItem.buttonText,
            buttonType: 'button',
            taggingInfo: {
              componentName: 'FeaturedPhrase',
              componentProduct: '',
              componentContent: 'interes',
              componentVariation: 'all',
            },
            font: 'regular',
            link: phraseItem.buttonLink,
            color: 'white_blue',
            size: {
              h: 'large',
              w: 'full',
            },
            labelSize: 'medium',
            border: 'no-border-radius',
            textTransform: 'initial',
            tabletProps: {
              size: {
                w: 'medium',
              },
            },
            desktopProps: {
              size: {
                w: 'medium',
              },
            },
          },
        },
        backgroundImg: fixUrl(fields.soluciones[0].fields.urlImg) || 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/FD-TESTIMONIAL.jpg',
        titleImage: fields.soluciones[0].fields.title
          && fields.soluciones[0].fields.title.includes('/')
          && fixUrl(fields.soluciones[0].fields.title),
      }

      return newFields;
    } catch (error) {
      const context = createSondaContext('empresas');
      const sonda = new Sonda({
        processName: 'moduloFraseDestacada',
        context,
        filePath: 'utils/soluciones',
      });
      sonda.errorMessage({ error });
      return null;
    }
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de no te pierdas nada
 * @returns
 * Devuelve la informacion para el modulo de no te pierdas nada
 */
export const moduloNoTePierdasNadaSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      featuredCards: fields.featuredCards === 'true',
      isSlider: true,
      bgColor: 'grey1',
      direction: 'column',
      segment: 'emp',
      maxSlidesToShow: 3,
      cardTheme: 'large',
      taggingInfo: {
        componentContent: 'tienda-electronica-all',
        componentName: 'tienda-electronica',
        componentProduct: '',
        componentPerso: {
          versionTest: '',
        },
        componentVariation: 'all',
      },
      components: {
        'TextInfo-1': {
          color: 'grey8',
          kind: 'paragraph',
          fontType: 'font-light',
          align: 'center',
          level: 2,
          size: 'title02',
          text: fields.title,
          segment: 'emp',
          tabletProps: {
            align: '',
          },
        },
      },
    }

    // const components = fields.no_te_pierdas_nada.reduce((arr, item) => {
    //   const product = {
    //     title: item.fields.title,
    //     subtitle: item.fields.description,
    //     icon: item.fields.icon,
    //     link: fixUrl(item.fields.urlFicha) || 'https://empresas.blogthinkbig.com',
    //     src: fixUrl(item.fields.backgroundImg) || 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/no-te-pierdas-mod-01.png',
    //   };
    //   arr = [...arr, product];
    //   return arr;
    // }, [])

    // newFields.components = components;
    // return newFields;

    const items = {};
    fields.no_te_pierdas_nada.forEach((item, index) => {
      items[`ProductItemCard-${index}`] = {
        components: {
          'TextInfo-1': {
            color: 'white',
            kind: 'heading',
            fontType: 'font-light',
            align: 'center',
            level: 3,
            size: 'title04',
            text: item.fields.title,
            segment: 'emp',
          },
          'TextInfo-2': {
            color: 'white',
            kind: 'heading',
            fontType: 'font-light',
            align: 'center',
            level: 3,
            size: 'title04',
            text: item.fields.description,
            segment: 'emp',
          },
          'CustomLink-1': {
            link: fixUrl(item.fields.urlFicha),
            taggingInfo: {
              componentName: 'no-te-pierdas-nada',
              componentContent: 'no-te-pierdas-nada-1',
              componentProduct: 'blog-think-big',
              componentPerso: '',
              componentVariation: 'all',
            },
          },
          'Image-1': {
            src: fixUrl(item.fields.backgroundImg),
            alt: item.fields.title,
          },
          'SvgIconLoader-1': {
            id: item.fields.icon,
            kind: 'L',
            color: 'white',
            size: 72,
            backgroundColor: 'transparent',
            segment: 'emp',
          },
        },
      };
    });
    if (Object.keys(items).length > 0) {
      const newComponents = { ...newFields.components, ...items };
      newFields.components = newComponents;
      return newFields;
    }
    return null;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloNoTePierdasNadaSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};


/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo sub cabecera
 * @returns
 * Devuelve la informacion para el modulo sub cabecera
 */
export const moduloSubCabeceraSolucionesDigitales = (fields) => {
  try {
    const items = {

    };
    const iconList = fields['Listado de portadas'].reduce((arr, item) => {
      const product = {
        title: item.fields.title,
        alias: item.alias,
        icon: item.fields.icono,
        link: item.fields.url || 'https://empresas.blogthinkbig.com',
      };
      arr = [...arr, product];
      return arr;
    }, [])
    items.iconList = iconList;
    return items;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloNoTePierdasNadaSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de VideoBanner
 * @returns
 * Devuelve la informacion para el modulo de VideoBanner
 */
export const moduloVideoBannerSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      subClaim: fields.subClaim,
      claim: fields.claim,
      bucleVideo: fields.bucleVideo,
      urlVideo: fields.urlVideo,
      title: fields.title,
      button: fields.buttom,
      imgDesktop: fields.imgDesktop,
    }

    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloFraseDestacada',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};
/** @param {*} fields Información del modulo carrusel
 * @returns
 * Devuelve la informacion para el modulo carrusel
 */
export const moduloCarrousel = (fields) => {
  try {
    const items = {

    };
    const itemsList = fields.carrousel.reduce((arr, item) => {
      const info = {
        title: item.fields.title,
        description: item.fields.description,
      };
      arr = [...arr, info];
      return arr;
    }, [])
    items.itemsList = itemsList;
    return items;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloCarruselSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};


/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de VideoInterno
 * @returns
 * Devuelve la informacion para el modulo de VideoInterno
 */
export const moduloVideoInternoSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      align: fields.align,
      subClaim: fields.description,
      claim: fields.title,
      urlVideo: fields.urlVideo,
      imgDesktop: fields.imgDesktop,
    }

    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloVideoInterno',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que devuelve el objeto necesario para pintar el contactBar
 * @returns
 * Devuelve la informacion para el módulo de contactBar
 */
export const getContactBar = () => {
  try {
    const urlProdCompraContactBar = 'https://www.movistar.es/empresas/Privada/CompraManual/?idPWEB=78f5eb81c587b610VgnVCM1000003028240a____&codPSA=2ba67935a49c6410VgnVCM1000003028240a____&tesValue=visitacomercial';
    const contactBarProps = {
      ...contactBar,
      taggingInfo: {
        ...contactBar.taggingInfo,
        componentProduct: '',
      },
      components: {
        ...contactBar.components,
        'Button-1': {
          ...contactBar.components['Button-1'],
          link: urlProdCompraContactBar,
        },
      },
    }

    return contactBarProps;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'getContactBar',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de Menu Principal
 * @returns
 * Devuelve la informacion para el modulo de Menu principal
 */
export const moduloMenuPrincipal = (fields) => {
  try {
    const itemsList = fields['Listado de menus'].reduce((arr, item) => {
      const info = {
        title: item.fields.title,
        id: item.fields.id,
      };
      arr = [...arr, info];
      return arr;
    }, [])
    const url = fixUrl(fields.urlContratar);
    const items = { itemsList, url };
    return items;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloVideoInterno',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de Menu Principal
 * @returns
 * Devuelve la informacion para el modulo de Menu principal
 */
export const moduloStandardBanner = (fields) => {
  try {
    const newFields = {
      taggingInfo: {
        componentVariation: 'all',
        componentContent: 'Me interesa',
        componentName: 'Banner',
        componentProduct: fields.product.alias,
      },
      layout: 'Layout2_Distributiva',
      contentColors: {
        bgColor: 'blue',
        bgIconColor: 'blue-dark',
        bgPriceColor: 'white',
      },
      components: {
        'BgImage-1': {
          bgColor: 'black',
          div2Fit: 'full',
          picDesktop: {
            position: 'center',
            size: 'cover',
            src: `https://www.movistar.es/${fields.product.data.fields.imgBannerPrincipal}`,
            shadeLimit: false,
          },
          picTablet: {
            position: 'top',
            size: 'cover',
            src: `https://www.movistar.es/${fields.product.data.fields.imgBannerPrincipal}`,
            shadeLimit: false,
          },
          picMobile: {
            position: 'top',
            size: 'cover',
            src: `https://www.movistar.es/${fields.product.data.fields.imgBannerPrincipal}`,
            shadeLimit: false,
          },
        },
        'TextInfo-2': {
          color: 'white',
          text: fields.product.data.fields.nombreComercial,
          size: 'title02',
          segment: 'emp',
          fontType: 'font-regular',
          tabletProps: {
            size: 'title01',
          },
          desktopProps: {
            size: 'display03',
          },
        },
        'TextInfo-3': {
          className: 'banner_subtitle',
          color: 'white',
          kind: 'paragraph',
          fontType: 'font-regular',
          size: 'caption02',
          text: fields.product.data.fields.claimBannerPrincipal,
          segment: 'emp',
          tabletProps: {
            size: 'caption02',
          },
          desktopProps: {
            size: 'title045',
          },
        },
        'SvgIconLoader-1': {
          id: 'Clic',
          kind: 'M',
          color: 'white',
          size: 40,
        },
        'Claim-1': {
          label: fields.product.data.fields.bandaPromo,
          color: 'white',
          bgColor: 'trasparent',
          size: 'xsmall',
          segment: 'emp',
        },
        /* 'Price-1': {
          withSpace: false,
          decoration: 'linethrough',
          amount: 64,
          unity: '€',
          size: 'emp-40',
          color: 'white',
          opacity: 'op-0-5',
          fontType: 'font-regular',
          segment: 'emp',
        }, */
        'Price-2': {
          withSpace: false,
          amount: fixPVP(fields.product.data.fields.pvp),
          unity: `${fields.product.data.fields.unidad} ${fields.product.data.fields.subTitle.toLowerCase()}`,
          size: (fields.product.data.fields.unidad + fields.product.data.fields.subTitle).length > 10
            ? 'emp-18' : 'emp-28',
          color: 'blue-dark',
          fontType: 'font-regular',
          segment: 'emp',
        },
        'TextInfo-6': {
          text: '(imp. no incl.)',
          align: 'center',
          className: 'small',
          fontType: 'font-regular',
          color: 'blue-dark',
          segment: 'emp',
        },
        'TextInfo-4': {
          text: fields.product.data.fields.textPrice === 'true' && 'Desde',
          align: 'center',
          className: 'small',
          fontType: 'font-regular',
          color: 'blue-dark',
          segment: 'emp',
          size: fields.product.data.fields.unidad.length > 10 ? 'title06' : 'title045',
        },
        'Button-1': {
          label: fields.buttom_1,
          buttonType: 'button',
          borderRadius: 'small',
          taggingInfo: {
            debug: true,
          },
          link: fields.urlbuttom_1 !== '' ? fixUrl(fields.urlbuttom_1) : fixUrl(fields.product.data.fields.urlFicha),
          color: 'white_blue',
          size: {
            w: 'full',
          },
          labelSize: 'small',
          font: 'bold',

          textTransform: 'initial',
          tabletProps: {
            size: {
              h: 'large',
              w: 'liquid',
            },
            labelSize: 'medium',
          },
          segment: 'emp',
          forceExternal: true,
          target: '_self',
        },
        contactBar: {
          visible: true,
          bgImage: 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/fd-novedades-empresas.jpg',
          fixedBar: false,
          taggingInfo: {
            componentVariation: 'all',
            componentProduct: fields.product.alias,
            componentName: 'ContactBar',
            componentContent: '',
          },
          components: {
            'Button-llamada': {
              segment: 'emp',
              buttonType: 'button',
              font: 'regular',
              border: 'no-border-radius',
              textTransform: 'initial',
              size: {
                h: 'medium',
                w: 'full',
              },
              labelSize: 'small',
              tabletProps: {
                size: {
                  h: 'large',
                  w: 'liquid',
                },
                labelSize: 'medium',
              },
              label: 'Hablar con experto',
              color: 'white_reverse',
              option: 'te-llamamos',
            },
            'Button-solicita': {
              segment: 'emp',
              buttonType: 'button',
              font: 'bold',
              border: 'no-border-radius',
              textTransform: 'initial',
              size: {
                h: 'medium',
                w: 'full',
              },
              labelSize: 'small',
              tabletProps: {
                size: {
                  h: 'large',
                  w: 'liquid',
                },
                labelSize: 'medium',
              },
              label: 'Solicitar visita',
              color: 'white_blue',
              option: 'solicitar-visita',
            },
          },
        },
      },
      fixedBar: true,
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloVideoInterno',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo banner
 * @returns
 * Devuelve la informacion para el módulo del banner
 */
export const moduloBannerHablaConExperto = (fields) => {
  try {
    const newFields = {
      components: {

        'BgImage-1': {
          bgColor: 'black',
          div2Fit: 'full',
          picDesktop: {
            position: 'center',
            size: 'cover',
            src: (fields.imgDesktop && `https://www.movistar.es${fields.imgDesktop}`) || '',
            shadeLimit: false,
          },
          picTablet: {
            position: 'top',
            size: 'cover',
            src: (fields.imgTablet && `https://www.movistar.es${fields.imgTablet}`)
              || (fields.imgDesktop && `https://www.movistar.es${fields.imgDesktop}`)
              || '',
            shadeLimit: false,
          },
          picMobile: {
            position: 'center',
            size: 'cover',
            src: (fields.imgMobile && `https://www.movistar.es${fields.imgMobile}`) || '',
            shadeLimit: false,
          },
        },
        'TextInfo-1': {
          align: 'center',
          color: 'white',
          kind: 'heading',
          level: 3,
          size: 'title05',
          fontType: 'font-regular',
          text: fields.title,
          segment: 'emp',
          tabletProps: {
            size: 'title03',
            align: 'left',
            fontType: 'font-regular',
          },
          desktopProps: {
            size: 'title03',
          },
        },
        'TextInfo-2': {
          align: 'center',
          kind: 'paragraph',
          color: 'white',
          fontType: 'font-regular',
          size: 'title06',
          segment: 'emp',
          text: fields.description,
          tabletProps: {
            size: 'title05',
            align: 'left',
          },
          desktopProps: {
            size: 'title05',
          },
        },
        'Button-1': {
          label: fields.buttonText,
          link: fields.urlBotom,
          target: '_blank',
          buttonType: 'button',

          color: 'white_blue',
          size: {
            h: 'large',
            w: 'full',
          },
          labelSize: 'medium',
          font: 'regular',
          borderRadius: 'small',
          tabletProps: {
            size: {
              h: 'large',
              w: 'double',
            },

          },
          segment: 'emp',
        },
        C2CEmpProps: [
          {
            porcentaje: '88',
            destino: 'Gevico',
            tes: 'SI',
            tipoTes: 'FONGEV_B',
          },
          {
            porcentaje: '12',
            destino: 'InsideSales',
            tes: 'SI',
            tipoTes: 'FONINS_B',
          },
        ],
      },
      // otracosa: {
      //   backgroundImg: (fields.imgDesktop && `https://www.movistar.es${fields.imgDesktop}`) || '',
      //   backgroundColor: fields.backgroundColor || '',
      //   'TextInfo-1': {
      //     text: fields.claim,
      //     color: 'white',
      //     kind: 'heading',
      //     level: 1,
      //     size: 'title04',
      //     fontType: 'font-light',
      //     align: 'left',
      //     segment: 'emp',
      //     tabletProps: {
      //       size: 'display02',
      //       align: 'center',
      //     },
      //     desktopProps: {
      //       size: 'display02',
      //       align: 'center',
      //     },
      //   },
      //   'TextInfo-2': {
      //     text: fields.subClaim,
      //     color: 'white',
      //     kind: 'paragraph',
      //     size: 'caption01',
      //     fontType: 'font-light',
      //     align: 'left',
      //     segment: 'emp',
      //     tabletProps: {
      //       size: 'title045',
      //       align: 'center',
      //     },
      //     desktopProps: {
      //       size: 'title045',
      //       align: 'center',
      //     },
      //   },
      // },
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'móduloBannerHablaConExperto',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
}

export const moduloFAQ = (fields) => {
  const newFields = {
    questions: [],
    title: fields.fields.title,
    titleOptions: {
      align: 'center', fontType: 'font-light', size: 'title03', color: 'blue-dark', segment: 'emp', level: 2,
    },
    faqItemOptions: {
      default: {
        color: {
          title: 'blue',
          text: 'blue',
          icon: 'blue',
        },
      },
      activated: {
        color: {
          text: 'blue',
          icon: 'blue',
        },
      },
    },
    variant: 'DEFAULT',
    segment: 'emp',

  }
  try {
    fields.fields.listadoFAQS.map((item) => {
      const questionItem = {
        title: item.fields.title,
        content: item.fields.description,

      }
      newFields.questions.push(questionItem);
    });

    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloFAQ',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
}

/** @param {*} fields Información del módulo del wrapper de imágenes
 * @returns
 * Devuelve la informacion para el módulo wrapper de imágenes
 */
export const moduloFourKeys = (fields) => {
  try {
    const newFields = fields.fields.title ? {
      title: {
        text: fields.fields.title || '',
        bgColor: fields.fields.backgroundColor || '',
        color: 'blue',
        kind: 'heading',
        level: 2,
        size: 'title04',
        fontType: 'font-regular',
        segment: 'emp',
        align: 'center',
        tabletProps: {
          size: 'title03',
          align: 'center',
        },
        desktopProps: {
          size: 'title03',
          align: 'left',
        },
      },
      advantages: [],
    } : { advantages: [] }

    const listItems = fields.fields.claves.reduce((arr, item) => {
      const advantages = {
        title: {
          color: 'blue',
          kind: 'heading',
          level: 3,
          size: 'title04',
          fontType: 'font-regular',
          text: item.fields.title,
          segment: 'emp',
          align: 'center',
          tabletProps: {
            align: 'left',
          },
        },
        text: {
          color: 'grey7',
          kind: 'paragraph',
          size: 'title06',
          fontType: 'font-regular',
          text: item.fields.description,
          segment: 'emp',
          align: 'center',
          tabletProps: {
            align: 'left',
            size: 'title05',
          },
        },
        principalPhoto: fixUrl(item.fields.urlImg) || '',
        separatorPhoto: fixUrl(item.fields.urlImg2) || '',
        photoAlt: item.fields.alt || item.fields.title,
      }
      arr = [...arr, advantages];
      return arr;
    }, [])

    newFields.advantages = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloFourKeys',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo Descargas
 * @returns
 * Devuelve la informacion para el modulo Descargas
 */
export const moduloDescargas = (fields) => {
  try {
    const itemsList = fields['Listado de Documentos'].reduce((arr, item) => {
      const info = {
        title: item.fields.title,
        urlDescarga: item.fields.urlDescarga,
        icono: item.fields.icono,
      };
      arr = [...arr, info];
      return arr;
    }, [])
    const items = { itemsList };
    return items;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloDescarga',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};
/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo Carousel
 * @returns
 * Devuelve la informacion para el modulo Carousel
 */
export const moduloCarousel = (fields) => {
  try {
    const itemList = {};
    fields['Slider descriptivos'].forEach((element, index) => {
      itemList[`TextInfo-${index + 1}`] = {
        color: 'grey9',
        kind: 'paragraph',
        size: 'title06',
        fontType: 'font-regular',
        text: element.fields.description,
        segment: 'emp',
        align: 'left',
        tabletProps: {
          size: 'title05',
          color: 'grey5',
          align: 'center',
        },
        desktopProps: {
          size: 'title04',
        },
      }
    });
    const testPropsNormal = {
      arrowColor: 'white',
      arrowSize: 'small',
      arrowOpacity: 'op-0-6',
      arrowBgColor: 'black',
      'TextInfo-1': {
        color: 'blue',
        kind: 'heading',
        level: 4,
        size: 'title04',
        fontType: 'font-regular',
        text: fields['Slider descriptivos'][0].fields.title,
        segment: 'emp',
        align: 'center',
      },
      content: {
        ...itemList,
      },
    }
    return testPropsNormal;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloCarousel',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de FixedBar
 * @returns
 * Devuelve la informacion para el modulo de FixedBar
 */
export const moduloFixedBar = (fields) => {
  try {
    const newFields = {
      taggingInfo: {
        componentVariation: 'all',
        componentContent: 'Me interesa',
        componentName: 'FixedBar',
        componentProduct: 'solucion-digital',
      },
      title: fields.product.data.fields.nombreComercial,
      basePrice: fixPVP(fields.product.data.fields.pvp),
      taxonomy: fields.product.productTaxonomy,
      link: fields.urlbuttom_2 !== '' && fixUrl(fields.urlbuttom_2),
      linkButton: fields.urlbuttom_1 !== '' ? fixUrl(fields.urlbuttom_1) : fixUrl(fields.product.data.fields.urlFicha),
      fromTag: 'Desde',
      components: {
        'Button-llamada': {
          segment: 'emp',
          buttonType: 'button',
          font: 'regular',
          border: 'no-border-radius',
          textTransform: 'initial',
          size: {
            h: 'medium',
            w: 'full',
          },
          labelSize: 'small',
          tabletProps: {
            size: {
              h: 'large',
              w: 'liquid',
            },
            labelSize: 'medium',
          },
          label: 'Hablar con experto',
          color: 'white_reverse',
          option: 'te-llamamos',
          product: fields.product.data.fields.name,
        },
        'Button-solicita': {
          segment: 'emp',
          buttonType: 'button',
          font: 'bold',
          border: 'no-border-radius',
          textTransform: 'initial',
          size: {
            h: 'medium',
            w: 'full',
          },
          labelSize: 'small',
          tabletProps: {
            size: {
              h: 'large',
              w: 'liquid',
            },
            labelSize: 'medium',
          },
          label: 'Solicitar visita',
          color: 'white_blue',
          option: 'solicitar-visita',
          product: fields.product.data.fields.name,
        },
      },
      c2cLabel: 'Hablar con experto',
      formLabel: 'Solicitar visita',
      contratarLabel: fields.buttom_1,
      unity: `${fields.product.data.fields.unidad} ${fields.product.data.fields.subTitle.toLowerCase()}`,
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloFixedBar',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};


/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo ServiceAccess
 * @returns
 * Devuelve la informacion para el modulo ServiceAccess
 */
export const moduloServiceAccess = (fields) => {
  try {
    const itemsList = fields.ListadoAccesos.reduce((arr, item) => {
      const info = {
        title: item.fields.title,
        description: item.fields.description1,
        imgDesktop: `https://www.movistar.es${item.fields.imgDesktop}`,
        alt: item.fields.alt || item.fields.title || '',
        theme: item.fields.backgroundColor,
        button1Link: item.fields.button1Link,
        button1Text: item.fields.button1Text,
        button2Link: item.fields.button2Link,
        button2Text: item.fields.button2Text,
      };
      arr = [...arr, info];
      return arr;
    }, [])
    const items = { itemsList, title: fields.title };
    return items;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloServiceAccess',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de banner inferior
 * @returns
 * Devuelve la informacion para el modulo banner inferior
 */
export const moduloBannerInferior = (fields) => {
  try {
    const newFields = {
      taggingInfo: {
        componentProduct: '',
        componentVariation: 'all',
        componentName: 'banner-secundario',
      },
      layout: 'Layout3_Fusion',
      components: {
        'BgImage-1': {
          bgColor: 'black',
          div2Fit: 'full',
          picDesktop: {
            position: 'center',
            size: 'cover',
            src: `https://www.movistar.es${fields.imgDesktop}`,
            shadeLimit: false,
          },
          picTablet: {
            position: 'top',
            size: 'cover',
            src: `https://www.movistar.es${fields.imgDesktop}`,
            shadeLimit: false,
          },
          picMobile: {
            position: 'top',
            size: 'cover',
            src: `https://www.movistar.es${fields.imgDesktop}`,
            shadeLimit: false,
          },
        },
        'TextInfo-1': {
          className: 'title',
          color: 'white',
          kind: 'heading',
          level: 2,
          fontType: 'font-thin',
          align: 'center',
          text: fields.title || '',
          segment: 'emp',
        },
        'TextInfo-2': {
          kind: 'paragraph',
          color: 'white',
          fontType: 'font-regular',
          size: 'title06',
          text: fields.subTitle || '',
          align: 'center',
          segment: 'emp',
          tabletProps: {
            fontType: 'font-light',
            size: 'title05',
          },
          desktopProps: {
            fontType: 'font-light',
            size: 'title05',
          },
        },
        'Button-1': {
          link: fields.urlFicha,
          target: '_blank',
          color: 'blue',
          className: 'upgrade-section__button',
          label: fields.buttom_1,
          labelSize: 'small',
          buttonType: 'button',
          taggingInfo: {
            componentName: fields.title || '',
            componentVariation: 'all',
            componentContent: fields.buttom || '',
            componentProduct: '',
          },
          size: {
            h: 'regular',
            w: 'full',
          },
          tabletProps: {
            size: {
              w: 'liquid',
            },
          },
          desktopProps: {
            size: {
              w: 'liquid',
            },
          },
          borderRadius: 'small',
          textTransform: 'initial',
          font: 'bold',
          segment: 'emp',
        },
      },
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloBannerInferior',
      context,
      filePath: 'utils/normalizerModules',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información de la sección de ofertas de empresas.
 * @returns
 * Devuelve la informacion para el modulo de ofertas de empresas.
 */
export const moduloOfertaEmpresas = (fields) => {
  try {
    const tabs = [];
    fields.secciones.map((field) => {
      tabs.push({
        text: field.fields.datosSeccion.fields.title,
        value: field.alias.substring(20).split('_')[0].toLowerCase(),
        products: [],
      });
      if (field.fields.contadorSeccion && field.fields.contadorSeccion.fields && field.fields.contadorSeccion.fields.endDate) {
        tabs[tabs.length - 1].contador = {
          endDate: field.fields.contadorSeccion.fields.endDate,
          segment: 'emp',
          colorTheme: 'blue-dark',
        }
        if (field.fields.contadorSeccion.fields.title) {
          tabs[tabs.length - 1].contador.components = {
            'TextInfo-1': {
              color: 'white',
              kind: 'span',
              size: 'caption01',
              fontType: 'font-regular',
              text: field.fields.contadorSeccion.fields.title,
              segment: 'emp',
            },
          };
        }
      }
      tabs[tabs.length - 1].buttons = {};
      tabs[tabs.length - 1].buttons.components = {};
      if (field.fields.buttonSeccion && field.fields.buttonSeccion.fields && field.fields.buttonSeccion.fields.linkButton1 && field.fields.buttonSeccion.fields.textButton1) {
        tabs[tabs.length - 1].buttons.components.button1 = {
          label: field.fields.buttonSeccion.fields.textButton1,
          buttonType: 'button',
          color: 'blue',
          link: fixUrlImg(field.fields.buttonSeccion.fields.linkButton1),
          size: {
            h: 'large',
            w: 'full',
          },
          labelSize: 'medium',
          font: 'regular',
          border: 'no-border-radius',
          tabletProps: {
            size: {
              h: 'large',
              w: 'double',
            },
          },
          segment: 'emp',
        };
      }

      if (field.fields.buttonSeccion && field.fields.buttonSeccion.fields && field.fields.buttonSeccion.fields.linkButton2 && field.fields.buttonSeccion.fields.textButton2) {
        tabs[tabs.length - 1].buttons.components.button2 = {
          label: field.fields.buttonSeccion.fields.textButton2,
          buttonType: 'button',
          color: 'blue_reverse',
          link: fixUrlImg(field.fields.buttonSeccion.fields.linkButton2),
          size: {
            h: 'large',
            w: 'full',
          },
          labelSize: 'medium',
          font: 'regular',
          border: 'no-border-radius',
          tabletProps: {
            size: {
              h: 'large',
              w: 'double',
            },
          },
          segment: 'emp',
        };
      }
      field.fields.products.map((product) => {
        tabs[tabs.length - 1].products.push({
          id: product.id,
          icon: '',
          title: product.name,
          img: product.data.fields.urlImg || 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/migedi/fusion-negocios-base-prin.jpg',
          link: product.data.fields.urlFicha,
          components: {
            promoBox: {
              kind: 'paragraph',
              fontType: 'font-bold',
              segment: 'emp',
              size: 'caption02',
              text: product.data.fields.bandaPromo,
            },
            nombre: {
              color: 'blue',
              kind: 'heading',
              level: 2,
              fontType: 'font-regular',
              segment: 'emp',
              size: 'title05',
              text: product.name,
            },
            descripcion: {
              color: 'grey6',
              kind: 'paragraph',
              fontType: 'font-regular',
              segment: 'emp',
              size: 'caption01',
              text: product.data.fields.ctz_claimPrincipal,
            },
            precioTachado: {
              color: 'grey3',
              decoration: 'linethrough',
              kind: 'paragraph',
              fontType: 'font-light',
              segment: 'emp',
              size: 'title02',
              text: product.data.fields.pvpTachado
                ? product.data.fields.pvpTachado.includes('€/mes')
                  ? product.data.fields.pvpTachado
                  : `${product.data.fields.pvpTachado}€`
                : '',
            },
            precio: {
              color: 'grey8',
              kind: 'paragraph',
              fontType: 'font-regular',
              segment: 'emp',
              size: 'title04',
              text: `${product.data.fields.pvp}${product.data.fields.unidad || ''}`,
            },
            impuestos: {
              color: 'grey5',
              kind: 'paragraph',
              fontType: 'font-regular',
              segment: 'emp',
              size: 'caption02',
              text: product.data.fields.tipoImpuesto,
            },
          },
        });
      });
    });
    fields.info = {
      tabs,
      taggingInfo: {
        debug: true,
      },
      components: {
        'TextInfo-1': {
          color: 'blue',
          kind: 'paragraph',
          fontType: 'font-regular',
          segment: 'emp',
          size: 'title045',
        },
      },
    };
    return fields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloNoTePierdasNadaSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
}

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de click box
 * @returns
 * Devuelve la informacion para el modulo click box
 */
export const moduloClickBox = (fields) => {
  try {
    const newFields = {
      components: {
        'BgImage-1': {
          picDesktop: {
            position: 'center',
            size: 'cover',
            src: (fields.imgDesktop && fixUrlImg(fields.imgDesktop)) || '',
          },
          picTablet: {
            position: 'top',
            size: 'cover',
            src: (fields.imgDesktop && fixUrlImg(fields.imgDesktop)) || '',
          },
          picMobile: {
            position: 'center',
            size: 'cover',
            src: (fields.imgMobile && fixUrlImg(fields.imgMobile)) || '',
          },
        },
        title: {
          align: 'center',
          color: 'white',
          kind: 'span',
          size: 'title02',
          fontType: 'font-regular',
          text: fields.title || '',
          segment: 'emp',
          tabletProps: {
            size: 'title01',
            align: 'center',
            fontType: 'font-regular',
          },
          desktopProps: {
            align: 'left',
            size: 'title01',
          },
        },
        descripcion: {
          align: 'center',
          kind: 'paragraph',
          color: 'white',
          fontType: 'font-regular',
          size: 'title06',
          segment: 'emp',
          text: fields.subTitle || '',
          tabletProps: {
            size: 'title05',
            align: 'center',
          },
          desktopProps: {
            size: 'title05',
            align: 'left',
          },
        },
        button: {
          label: fields.buttom || '',
          buttonType: 'button',
          color: 'white_blue',
          link: fields.urlFicha || '',
          size: {
            h: 'large',
            w: 'full',
          },
          labelSize: 'medium',
          font: 'regular',
          border: 'no-border-radius',
          tabletProps: {
            size: {
              h: 'large',
              w: 'double',
            },
          },
          segment: 'emp',
        },
      },
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloClickBox',
      context,
      filePath: 'utils/normalizerModules',
    });
    sonda.errorMessage({ error });
    return null;
  }
}
